import { memo } from 'react';

import { type Uploader } from '~/components/Filters/UploaderFilter/UploaderFilterCard';
import { UploaderSelect } from '~/components/Selects/Uploader/UploaderSelect';
import { type UploaderFilterType } from '~/store/filters/types';

export type UploaderFilterProps = {
  selectedOptions: Uploader[];
  uploadersOptions: Uploader[];
  onUploaderSelectionChange: (uploaders: Uploader[]) => void;
};

export const mapUploaderFilterToOption = (uploader: UploaderFilterType): Uploader => ({
  ...uploader,
  id: uploader.value,
});

export const mapOptionToUploaderFilter = (uploader: Uploader): UploaderFilterType => ({
  ...uploader,
  value: uploader.id,
});

export const UploaderFilter = memo(
  ({ onUploaderSelectionChange, uploadersOptions, selectedOptions }: UploaderFilterProps) => {
    return (
      <UploaderSelect
        hasDropdownOverlay
        size="large"
        uploaders={uploadersOptions}
        selectedUploaders={selectedOptions}
        onUploaderSelectionChange={onUploaderSelectionChange}
      />
    );
  },
);

UploaderFilter.displayName = 'UploaderFilter';
